import { createCookie } from '@utils/cookie';
import { JtagService } from './jtag-service';

const encodeCookie = (value: any): string => encodeURIComponent(JSON.stringify(value));

export const hideCookiePopup = (): void => {
  const header = document.querySelector('.js-header-wrapper');
  const cookieConsentPopup = document.querySelector('.js-cookie-consent-wrapper');

  if (header) {
    header.classList.remove('cookie-opened');
  }

  if (cookieConsentPopup) {
    cookieConsentPopup.classList.remove('opened');
  }
  const cookieValue = encodeCookie({ clc: true });
  createCookie(
    'JEC',
    cookieValue,
    { days: 365 }
  );

  JtagService.trackCustomEvent('cookie_law_consensus');
}
